import { render } from "./WithdrawalPopup.vue?vue&type=template&id=65663aea&scoped=true&ts=true"
import script from "./WithdrawalPopup.vue?vue&type=script&lang=ts"
export * from "./WithdrawalPopup.vue?vue&type=script&lang=ts"

import "./WithdrawalPopup.vue?vue&type=style&index=0&id=65663aea&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65663aea"]])

export default __exports__